import { Router } from "express";
import * as cheerio from "cheerio";
import { requireAuth, type AuthRequest } from "../lib/auth";

const router = Router();

const LABEL_MAP: Record<string, string> = {
  "اسم المناقصة": "title",
  "اسم المنافسة": "title",
  "الجهة الحكومية": "governmentEntity",
  "الجهة": "governmentEntity",
  "اسم الجهة": "governmentEntity",
  "قطاع المناقصة": "sector",
  "نوع المناقصة": "tenderType",
  "نوع المنافسة": "tenderType",
  "رقم المناقصة": "competitionNumber",
  "رقم المنافسة": "competitionNumber",
  "الرقم المرجعي": "referenceNumber",
  "وصف المناقصة": "description",
  "العرض من المناقصة": "description",
  "العرض": "description",
  "تاريخ الإغلاق": "deadline",
  "آخر موعد للتقديم": "deadline",
  "تاريخ الانتهاء": "deadline",
  "المدينة": "city",
  "المنطقة": "city",
};

function parseEtimadHtml(html: string): Record<string, string> {
  const $ = cheerio.load(html);
  const result: Record<string, string> = {};

  $("table tr, .detail-row, .info-row").each((_i, row) => {
    const cells = $(row).find("td, th");
    if (cells.length >= 2) {
      const texts = cells.toArray().map((c) => $(c).text().trim());
      for (let i = 0; i < texts.length - 1; i++) {
        const label = texts[i].replace(/\s+/g, " ").trim();
        const value = texts[i + 1].replace(/\s+/g, " ").trim();
        if (label && value) {
          const mapped = LABEL_MAP[label];
          if (mapped && !result[mapped]) result[mapped] = value;
        }
      }
    }
  });

  $(".field-label, .label, [class*='label'], [class*='Label']").each((_i, el) => {
    const label = $(el).text().trim();
    const value =
      $(el).next().text().trim() ||
      $(el).parent().find(".field-value, .value, [class*='value'], [class*='Value']").first().text().trim();
    if (label && value) {
      const mapped = LABEL_MAP[label];
      if (mapped && !result[mapped]) result[mapped] = value;
    }
  });

  $("*").each((_i, el) => {
    const text = $(el).clone().children().remove().end().text().trim();
    const mapped = LABEL_MAP[text];
    if (mapped && !result[mapped]) {
      const sibling = $(el).next().text().trim() || $(el).siblings().last().text().trim();
      if (sibling && sibling !== text) result[mapped] = sibling;
    }
  });

  return result;
}

router.post("/tenders/fetch-etimad", requireAuth, async (req: AuthRequest, res, next) => {
  try {
    const { url } = req.body as { url?: string };
    if (!url || !url.includes("etimad.sa")) {
      return res.status(400).json({ error: "يرجى إدخال رابط صحيح من منصة اعتماد" });
    }

    const response = await fetch(url, {
      headers: {
        "User-Agent":
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
        "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
        "Accept-Language": "ar-SA,ar;q=0.9,en;q=0.8",
        "Referer": "https://tenders.etimad.sa/",
      },
      signal: AbortSignal.timeout(15_000),
    });

    if (!response.ok) {
      return res.status(502).json({ error: `تعذر جلب الصفحة (${response.status})` });
    }

    const html = await response.text();
    if (!html || html.length < 200) {
      return res.status(502).json({ error: "الصفحة فارغة أو محمية" });
    }

    const extracted = parseEtimadHtml(html);

    if (Object.keys(extracted).length === 0) {
      return res.status(422).json({
        error: "لم نتمكن من استخراج بيانات المناقصة. تأكد أن الرابط صحيح وأن الصفحة قابلة للوصول.",
      });
    }

    res.json(extracted);
  } catch (err: any) {
    if (err?.name === "TimeoutError" || err?.name === "AbortError") {
      return res.status(504).json({ error: "انتهت مهلة الاتصال بمنصة اعتماد" });
    }
    next(err);
  }
});

export default router;
